@if (tab) {
    <cerrix-loader [cerrixTab]="tab"></cerrix-loader>
}
@if (data && ((tab && !tab.showLoader) || kriGuids)) {
    @for (kriData of data; track kriData) {
        <div class="detail-page-card">
            <div class="detail-page-card-body">
                <kri-data-graph
                    [kriGuid]="kriData.guid"
                    [showOpen]="true"
                    [preLoadedData]="kriData"
                ></kri-data-graph>
            </div>
        </div>
    }
}
